import { injectCpmsBoTicketApi } from '@delmonicos/shared-sdk/libs/cpms/src/clients/redux/cpms-bo-ticket.service';

import { baseApi } from '@service/base-api.service';

export const ticketApi = injectCpmsBoTicketApi(baseApi);

export const {
  useCpmsBoCreateTicketMutation,
  useCpmsBoUpdateTicketMutation,
  useCpmsBoGetTicketsPaginatedQuery,
  useCpmsBoGetTicketQuery,
  useCpmsBoSubscribeToTicketNotificationsMutation,
  useCpmsBoUnsubscribeFromTicketNotificationsMutation,
  useCpmsBoDeleteTicketMutation,
  useCpmsBoAddMessageMutation,
} = ticketApi;
